import React from 'react'
import { useEffect } from 'react'
import "./main.css"
import "./com.css"

function Contact() {
    useEffect(() => {
        window.scroll(0,0)
    }, [])

    return (
        <div className="contenu ">
            <div className="sidePhoto conseil"></div>
            <div id="textCom">
                <h2>Audit et conseil en gestion</h2>
                <div className="parag">
                    <p>Nous vous accompagnons en établissant ensemble un <strong>diagnostic</strong> visant à mettre en évidence les principales caractéristiques de votre <strong>structure associative</strong> du point de vue <strong>organisationnel</strong>, <strong>financier</strong> et <strong>stratégique</strong>. Ceci dans le but de cerner vos points forts, faibles ou non conformes, afin de <strong>déterminer vos axes d'amélioration</strong>.</p>
                </div>
                <div className="parag">
                    <p>Nous pourrons ensuite vous aider à <strong>mettre en place</strong>, selon vos besoins, des <strong>process</strong> pour gérer de façon optimum votre structure tant du point de vue organisationnel que financier. Dans le but de <strong>simplifier le fonctionnement</strong> et d’<strong>améliorer votre rentabilité</strong>.</p>
                </div>
                <div className="parag">
                    <p>Nous travaillerons ainsi ensemble sur la <strong>mise en place d’outils</strong> simples et nécessaires pour la <strong>gestion de votre structure</strong>. Dans le but de quantifier, mais également de mieux maîtriser votre masse salariale, vos charges et vos recettes, avec l’aide d’un budget prévisionnel qui vous servira de guide pour <strong>atteindre vos objectifs financiers</strong> de l’année ainsi qu’à plus long terme.</p>
                </div>
                <div className="parag">
                    <h3>Nous pourrons également vous guider dans :</h3>
                </div>

                <ul className="ulEspace">
                    <li>L’obtention de <strong>nouvelles sources de financement</strong> : demandes de subventions ou recherche de partenaires.</li>
                    <li>La <strong>planification</strong> de vos <strong>investissements matériels</strong> et son <strong>financement</strong>, afin d’avoir toujours du <strong>matériel à la pointe</strong>, pour être plus attractif et garantir une <strong>pratique sécuritaire</strong>.</li>
                    <li>La réalisation d’une <strong>étude de marché</strong> pour vous aider à faire des <strong>choix</strong>, afin que votre <strong>offre</strong> soit <strong>innovante</strong>, <strong>attractive</strong> et <strong>adaptée</strong> aux besoins de votre clientèle.  <strong>Correctement positionnée</strong> en terme de <strong>prix</strong> face à la concurrence déjà en place, et donc bien intégrée dans le tissus économique local.</li>
                    <li>La vérification ou la <strong>mise en place des protocoles</strong> qui permettent la <strong>pratique</strong> de votre activité dans le <strong>respect des normes de sécurité</strong> en vigueur.</li>
                    <li>La <strong>promotion de vos activités</strong> pour donner de la <strong>visibilité</strong> à votre structure, <strong>renforcer vos liens</strong> avec le <strong>public</strong>, vos <strong>partenaires</strong> et les <strong>collectivités</strong> locales.</li>
                </ul>
                <div className="parag">
                    <p>Notre <strong>objectif commun</strong> : <strong>améliorer</strong> votre <strong>fonctionnement</strong> et votre <strong>santé financière</strong> pour <strong>pérenniser votre structure</strong>.</p>
                </div>
                <div className="parag">
                    <p>Tout ceci dans le but de vous permettre d’être <strong>autonome</strong>, <strong>performant</strong> et <strong>rentable</strong>, toujours <strong>à la pointe</strong> de ce qui se fait de mieux <strong>dans votre domaine</strong>.</p>
                </div>
                <div className='rajout_vide'></div>
            </div>
        </div>
    )
}

export default Contact



